import Vue from "vue";
import App from "./App.vue";
import "@/assets/css/normalize.css"; // 初始化样式
import { requests } from "@/assets/js/api/https";
import { api } from "@/assets/js/api/api";
import { fetch, post } from "@/assets/js/api/request"; // 封装get、post请求
import { jsonp } from "vue-jsonp";

// import 'lib-flexible';
import router from "./router";
Vue.config.productionTip = false;
// 按需引入Element
import { Icon, Select, Option, Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import store from "./store";
Vue.use(Icon);
Vue.use(Select);
Vue.use(Option);

router.afterEach((to) => {
    if (Object.keys(to.query).length > 0) {
        console.log(to, "获取url的值");
        if (to.query.id !== null) {
            localStorage.setItem("deptId", to.query.id);
        } else {
            localStorage.removeItem("deptId");
        }
    } else {
        localStorage.removeItem("deptId");
    }
});

Object.assign(Vue.prototype, {
    $post: post,
    $get: fetch,
    $jsonp: jsonp,
    $http: requests,
    $api: api,
    $message: Message
});

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
